import * as React from 'react';
import { Tree } from '@shared/ui-native/Tree';


export class AssignmentFilesSelector extends React.Component<{
    treeData: ITreeData,
    checkedUuids: string[],
    onChange: any
}> {
    treeWrapperEl: HTMLDivElement = null;
    tree: Tree = null;

    componentDidMount() {
        this.tree = new Tree({
            rootEl: $(this.treeWrapperEl),
            showCheckboxes: true,
            selectionCheckbox: true,
            showRoot: false,
            hideEmptyFoldersAlways: true,
            storageKey: 'vehicles__rights__tree-settings'
        });

        this.tree.on('render', () => {
            this.selectModelsInTree(this.props.checkedUuids, true);

            this.tree.on('check', (e, data) => {
                this.props.onChange(this.tree.getChecked().filter(c => c.isFile()).map(c => c.uuid))
            });
        });

        this.tree.initAndRender(this.props.treeData, true);
    }

    componentWillUnmount() {
        if (this.tree) {
            this.tree.destroy();
            this.tree = null;
        }
    }

    componentDidUpdate(prevProps: Readonly<{ checkedUuids: string[]; treeData: ITreeData }>) {
        if (this.props.checkedUuids !== prevProps.checkedUuids && this.props.checkedUuids.slice().sort().join() !== prevProps.checkedUuids.slice().sort().join()) {
            this.selectModelsInTree(this.props.checkedUuids, true);
        }
    }

    render() {
        return (
            <div>
                <div ref={el => this.treeWrapperEl = el}></div>
            </div>
        );
    }

    destroy = () => {

    }

    private selectModelsInTree(modelUuids: string[], silent = false) {
        if (!this.tree) return;

        modelUuids = modelUuids || [];

        this.tree.each(child => {
            if (!child.state.enabled) {
                child.setEnabled(true);
            }

            if (child.isFile()) {
                child.setChecked(modelUuids.includes(child.uuid) ? 1 : 0, silent);
            }
            else if (child.isLink()) {
                child.setChecked(modelUuids.includes(child.ajaxData.modelUuid) ? 1 : 0, true, false);
            }
            else {
                child.setChecked(0, silent);
            }
        }, true);

        this.tree.calculateCheckboxes();
    }

    getSelectedModels(): string[] {
        if (!this.tree) return;

        const modelUuids = [];

        this.tree.each(child => {
            if (child.state.checked === 1) {
                if (child.isFile()) {
                    modelUuids.push(child.uuid);
                }
            }
        }, true);

        return modelUuids;
    }
}
